import { render, staticRenderFns } from "./infoCard.vue?vue&type=template&id=694f0648&scoped=true"
import script from "./infoCard.vue?vue&type=script&lang=js"
export * from "./infoCard.vue?vue&type=script&lang=js"
import style0 from "./infoCard.vue?vue&type=style&index=0&id=694f0648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f0648",
  null
  
)

export default component.exports